/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RightToBuild } from './rightToBuild.model';
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { BuildingJpvDto } from './buildingJpvDto.model';
import { JpvDocumentDto } from './jpvDocumentDto.model';
import { ParcelDto } from './parcelDto.model';
import { UnitDto } from './unitDto.model';


export interface JpvSectionSimpleDto { 
    buildingK?: BuildingJpvDto;
    buildingPro?: BuildingJpvDto;
    documents: Array<JpvDocumentDto>;
    id?: number;
    parcelK?: ParcelDto;
    parcelPro?: ParcelDto;
    popisPravnihoVztahu?: string;
    poradiCas?: string;
    poradiText?: string;
    rightToBuildK?: RightToBuild;
    rightToBuildPro?: RightToBuild;
    subjectContactK?: SubjectContactResponseDto;
    subjectContactPro?: SubjectContactResponseDto;
    typravKod?: number;
    typravNazev?: string;
    unitK?: UnitDto;
    unitPro?: UnitDto;
}

